import ProfileMenu from "./ProfileMenu";

export default ProfileMenu;
